import script from "./NoRoutesCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./NoRoutesCard.vue?vue&type=script&setup=true&lang=ts"

import "./NoRoutesCard.vue?vue&type=style&index=0&id=7503940b&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7503940b"]])

export default __exports__